export default __webpack_public_path__ + "static/lumc-e92e2b9f634883774cc40506ee7dd140.png";